export async function extractApiErrorMessage(response) {
    try {
        const body = await response.json();
        const detail = body?.detail?.message ?? body?.detail;
        if (typeof detail === "string") {
            return detail;
        }
    }
    catch (error) {
        console.warn("Failed to parse API error response as JSON:", error);
    }
    return response.statusText || "Unknown error";
}
export class SessionConnectionError extends Error {
    closeCode;
    closeReason;
    constructor(message, options) {
        super(message);
        this.name = "SessionConnectionError";
        this.closeCode = options?.closeCode;
        this.closeReason = options?.closeReason;
    }
}
//# sourceMappingURL=errors.js.map